export const SITE_URL = 'https://timmers-bv.nl';
export const LOGO_URL = `${SITE_URL}/media/logo/websites/1/logo-large.png`;
export const PRODUCT_IMAGE_BASE_URL = 'https://timmers.bakaglass.nl/uploads/product/images';

export const categories = [
  {
    slug: 'douche-bad',
    name: 'Douche & Bad',
    description: 'Bekijk douchebeslag, badbeslag, stabilisatiestangen, afdichtprofielen en toebehoren voor professionele glasprojecten bij Timmers BV.',
  },
  {
    slug: 'interieurbeglazing',
    name: 'Interieurbeglazing',
    description: 'Ontdek glasbeslag en oplossingen voor glazen binnendeuren, scheidingswanden en interieurbeglazing bij Timmers BV.',
  },
  {
    slug: 'balustrade',
    name: 'Balustrade',
    description: 'Bestel balustradebeslag, profielen en glasbenodigdheden voor veilige en stijlvolle balustrades bij Timmers BV.',
  },
  {
    slug: 'glasartikelen',
    name: 'Glasartikelen',
    description: 'Bekijk glasartikelen, beglazingsmaterialen en verwerkingsproducten voor de professionele glaswereld bij Timmers BV.',
  },
  {
    slug: 'glasoplossingen',
    name: 'Glasoplossingen',
    description: 'Vind glasoplossingen, profielen en montageproducten voor uiteenlopende glastoepassingen bij Timmers BV.',
  },
  {
    slug: 'voorzetramen',
    name: 'Voorzetramen',
    description: 'Bekijk aluminium en houten voorzetramen, onderdelen en toebehoren voor isolerende raamoplossingen bij Timmers BV.',
  },
  {
    slug: 'vitrine-meubelbeslag',
    name: 'Vitrine- en meubelbeslag',
    description: 'Bestel vitrinebeslag, meubelbeslag, sloten, scharnieren en toebehoren voor glas in meubels en vitrines.',
  },
  {
    slug: 'ventilatieroosters',
    name: 'Ventilatieroosters',
    description: 'Bekijk ventilatieroosters en glasgerelateerde ventilatieoplossingen voor professionele toepassingen.',
  },
];

export const staticRoutes = {
  '/': {
    title: 'Timmers BV - Groothandel in Glas, Glasbeslag & Artikelen',
    description: 'Timmers BV is uw groothandel voor glas, glasbeslag en beglazingsmaterialen. Gespecialiseerd in glastoepassingen en eigen transport door heel Nederland en Vlaanderen.',
    h1: 'Glas, glasbeslag en glasartikelen',
    body: 'Timmers BV is een groothandel in glas, glasbeslag en beglazingsmaterialen gevestigd in Oosterhout. Wij leveren producten voor professionele glastoepassingen met eigen transport door Nederland en Vlaanderen.',
  },
  '/webshop': {
    title: 'Webshop Timmers BV - Glas & Glasbeslag Online Bestellen',
    description: 'Bestel glas, glasbeslag en glasartikelen eenvoudig online in de Timmers BV webshop. Ruim assortiment voor professionele glasprojecten.',
    h1: 'Webshop voor glas, glasbeslag en glasartikelen',
    body: 'Bekijk het assortiment glasbeslag, douchebeslag, balustradebeslag, glasartikelen, ventilatieroosters en toebehoren in de Timmers BV webshop.',
  },
  '/webshop/products': {
    title: 'Alle webshopproducten - Timmers BV',
    description: 'Bekijk alle indexeerbare webshopproducten van Timmers BV voor glas, glasbeslag, glasartikelen en beglazingsmaterialen.',
    h1: 'Alle webshopproducten',
    body: 'Zoek en filter door het complete webshopassortiment van Timmers BV voor professionele glasproducten en glasbeslag.',
  },
  '/contact': {
    title: 'Contact opnemen met Timmers BV - Oosterhout',
    description: 'Heeft u vragen over glas of glasbeslag? Neem contact op met Timmers BV in Oosterhout. Wij helpen u graag met producten en maatwerk.',
    h1: 'Waar kunnen wij u mee helpen?',
    body: 'Neem contact op met Timmers BV in Oosterhout via telefoonnummer 0031 (0)162 461175 of e-mail info@timmers-bv.nl. Openingstijden: maandag tot en met donderdag van 8:00 tot 17:00 en vrijdag van 8:00 tot 16:00.',
  },
  '/account-aanvragen': {
    title: 'Account aanvragen voor de webshop - Timmers BV',
    description: 'Vraag een account aan voor de Timmers BV webshop. Wij controleren de aanvraag voordat uw bedrijf handmatig in Baka wordt toegevoegd.',
    h1: 'Account aanvragen',
    body: 'Vraag een account aan voor de Timmers BV webshop. Timmers controleert de bedrijfsgegevens en voegt klanten pas na handmatige controle toe in Baka.',
  },
  '/about': {
    title: 'Over Timmers BV - Specialist in glas en glasbeslag',
    description: 'Lees meer over Timmers BV, groothandel in glas, glasbeslag en beglazingsmaterialen voor de professionele glaswereld.',
    h1: 'Over Timmers BV',
    body: 'Timmers BV is gespecialiseerd in glastoepassingen, glasbeslag en de toelevering van verwerkingsmaterialen voor de glaswereld.',
  },
  '/privacy': {
    title: 'Privacyverklaring - Timmers BV',
    description: 'Lees hoe Timmers BV omgaat met persoonsgegevens, cookies en privacy.',
    h1: 'Privacyverklaring',
    body: 'In deze privacyverklaring leest u hoe Timmers BV persoonsgegevens verwerkt en beschermt.',
  },
  '/retourneren': {
    title: 'Retourneren - Timmers BV',
    description: 'Lees hoe retourneren werkt bij Timmers BV en download het retourformulier voor uw zending.',
    h1: 'Retourneren',
    body: 'Bekijk de retourvoorwaarden van Timmers BV en gebruik het retourformulier voor uw retourzending.',
  },
};

export const getCategoryByPath = (pathname) => {
  const match = pathname.match(/^\/webshop\/category\/(.+?)\/?$/);
  if (!match) return null;

  const slugChain = match[1].split('/').filter(Boolean);
  const slug = slugChain[slugChain.length - 1];
  const category = categories.find((item) => item.slug === slug);

  if (category) {
    return {
      ...category,
      slugChain,
      path: `/webshop/category/${slugChain.join('/')}`,
    };
  }

  const name = slug.replace(/-/g, ' ').replace(/\b\w/g, (letter) => letter.toUpperCase());
  return {
    slug,
    slugChain,
    name,
    path: `/webshop/category/${slugChain.join('/')}`,
    description: `Bekijk ons assortiment ${name.toLowerCase()} bij Timmers BV. Professionele glasproducten met eigen transport door heel Nederland en Vlaanderen.`,
  };
};

export const getProductSlugFromPath = (pathname) => {
  const match = pathname.match(/^\/webshop\/product\/([^/]+)\/?$/);
  return match ? decodeURIComponent(match[1]) : null;
};

export const stripHtml = (html = '') => html
  .replace(/<[^>]*>/g, ' ')
  .replace(/\s+/g, ' ')
  .trim();

export const truncate = (text = '', maxLength = 155) => {
  if (text.length <= maxLength) return text;
  return `${text.slice(0, maxLength - 1).trim()}...`;
};

export const getProductMeta = (product) => {
  const title = product?.webshopTitle || product?.description || product?.name || 'Product';
  const plainDescription = stripHtml(product?.webshopMetaDescription || product?.webshopDescription || product?.description || '');
  const description = truncate(plainDescription || `Bekijk ${title} in de webshop van Timmers BV. Professionele glasproducten en glasbeslag met eigen transport.`);
  const image = product?.image ? `${PRODUCT_IMAGE_BASE_URL}${product.image}` : LOGO_URL;

  return {
    title: `${title} - Timmers BV`,
    description,
    h1: title,
    body: description,
    image,
  };
};

export const getRouteMeta = (pathname, product = null) => {
  const normalizedPath = pathname !== '/' ? pathname.replace(/\/$/, '') : '/';
  const productSlug = getProductSlugFromPath(normalizedPath);

  if (productSlug && product) {
    return {
      ...getProductMeta(product),
      canonicalPath: `/webshop/product/${productSlug}`,
      type: 'product',
    };
  }

  const category = getCategoryByPath(normalizedPath);
  if (category) {
    return {
      title: `${category.name} - Timmers BV Webshop`,
      description: category.description,
      h1: category.name,
      body: category.description,
      canonicalPath: category.path,
      category,
      type: 'category',
    };
  }

  const staticRoute = staticRoutes[normalizedPath] || staticRoutes['/webshop'];
  return {
    ...staticRoute,
    canonicalPath: normalizedPath,
    type: normalizedPath.startsWith('/webshop') ? 'webshop' : 'page',
  };
};
